export const IDENTITY_POOL_ID = "us-east-1:0f89a9f2-47b7-47aa-8989-7dee8557134c";
export const REGION = "us-east-1";
export const IDENTITY_POOL_REGION = "us-east-1";
export const USER_POOL_ID = "us-east-1_dmBsqHw3v";
export const USER_POOL_WEB_CLIENT_ID = "fv3pp8oqgtao5km17e5fij71q";
export const GOOGLE_CAPTCHA_SITE_KEY = "6LeiqdsUAAAAAIwAd-bO-So5OlQQq3fAlKZgjLo8";
export const GOOGLE_PLACES_API_KEY = "AIzaSyBk-vcLe2wm0TEIF5TgIjCufML1hZB1_YE";
